<template>
    <div class="bg">
        <div class="content" style="height: 100%">
            <div class="info-wrapper" id="info">
                <div class="logo-wrapper">
                    <img class="logo" src="../assets/image/about_ic_logo@2x.png" />
                    <div id="app-introduce">{{ pageInfo.qrcode_download_introduce }}</div>
                </div>
            </div>
            <div class="footer" style="bottom: 0px">
                <div class="download-wrapper">
                    <p class="remind-text">
                        {{ pageInfo.qrcode_download_remind }}
                    </p>
                    <a id="app-download" @click="download">{{
                        pageInfo.qrcode_download_download
                    }}</a>
                    <div class="select-div">
                        <img
                            v-if="['ar', 'he'].includes(lang)"
                            class="select-img-left"
                            src="../assets/image/more_rtl@3x.png"
                        />
                        <span
                            class="select-language"
                            @click="clickSelectLang"
                            >{{ languageName }}</span
                        >
                        <img
                            v-if="!['ar', 'he'].includes(lang)"
                            class="select-img-right"
                            src="../assets/image/more@3x.png"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getLanguageByCode } from 'smarthome-h5-common';
// import langObj from '../language/language';
import languageMap from '../language/languageNameMap';
import IosSelect from '../assets/js/iosSelect';
import VConsole from 'vconsole';
import { toApp } from '../utils/util';

// import MobileDetect from 'mobile-detect'
// import { getQueryString } from './utils/util'
export default {
    name: 'App',
    components: {},
    data() {
        return {
            androidMarketAppLink: 'market://details?id=com.midea.ai.overseas',
            androindLink:
                'https://play.google.com/store/apps/details?id=com.midea.ai.overseas',
            iosLink:
                'https://itunes.apple.com/us/app/midea-home/id1254346490?l=zh&ls=1&mt=8',
            pullUpAppUrl: '',
            // lang_flag: 0,
            href: '',
            // appInfo: {},
            lang: '', // 当前页面的语言
            appInfo: {},
            pageInfo: {}
        };
    },
    created() {
        this.init();
    },
    computed: {
        // pageInfo() {
        //     return langObj[this.lang];
        // },
        languageName() {
            return languageMap[this.lang];
        },
        isAndroid() {
            const ua = navigator.userAgent.toLowerCase();
            if (/iphone/.test(ua)) {
                return false;
            } else {
                return true;
            }
        },
        env() {
            if (
                location.href.match('sit-qrcode.msmartlife.net') ||
                location.href.match(/:\d{4}/) ||
                location.href.match('localhost')
            ) {
                return 'sit';
            } else {
                return 'prod';
            }
        }
    },
    methods: {
        init() {
            document.title = 'SmartHome';
            // 进入页面先直接跳转
            if (this.env === 'sit') {
                /* eslint-disable no-new */
                new VConsole();
            }

            this.setLangFlag();
            // this.lang_flag = 1;
            // this.setLanguage(this.lang_flag);
            /** UC浏览器和微信浏览器中，若立即跳转，则会出现UI问题：document节点的fontSize没有被设置成功 */
            setTimeout(() => {
                this.download();
            }, 100);
        },
        download() {
            if (this.isAndroid) {
                // location.href = this.androidMarketAppLink;
                // setTimeout(() => {
                //     location.href = this.androindLink;
                // }, 2000);
                toApp(this.androidMarketAppLink, this.androindLink);
            } else {
                location.href = this.iosLink;
            }
        },
        clickSelectLang() {
            const self = this;
            /* eslint-disable no-new */
            const appInfoList = [];

            // for (const key in langObj) {
            //     if (Object.hasOwnProperty.call(langObj, key)) {
            //         appInfoList.push({
            //             id: key,
            //             // ...langObj[key],
            //             value: languageMap[key]
            //         });
            //     }
            // }

            for (const key in languageMap) {
                appInfoList.push({
                    id: key,
                    value: languageMap[key]
                });
            }

            // console.log('appInfoList', appInfoList);

            new IosSelect(1, [appInfoList], {
                title: '',
                sureText: this.pageInfo.qrcode_download_confirm,
                closeText: this.pageInfo.qrcode_download_cancel,
                itemHeight: 50,
                itemShowCount: 5,
                oneLevelId: this.lang,
                showAnimate: true,
                addClassName: 'cust-style',
                callback: function (selectOneObj) {
                    console.log(selectOneObj);
                    self.lang = selectOneObj.id;
                    self.setPageInfo();
                }
            });
        },
        // setLanguage (index) {
        //     this.appInfo = appInfoList[index];
        // },

        handleLangCode(lang) {
                lang = lang.toLowerCase();
    
                if (lang.startsWith('en')) {
                    return 'en_US';
                }
                if (lang.startsWith('zh')) {
                    if (lang.match(/hk|hant/)) {
                        return 'zh_HK';
                    }
                    if (lang.match(/tw/)) {
                        return 'zh_TW';
                    }
                    return 'zh_CN';
                }
                return lang.substr(0, 2);
        },
        setLangFlag() {
            const lang =
                window.navigator.language || window.navigator.userLanguage;

            this.lang = this.handleLangCode(lang);

            this.setPageInfo();
        },
        async setPageInfo() {
            this.pageInfo = await getLanguageByCode(this.lang);
        }
    }
};
</script>

<style>
@import url('../assets/css/reset.css');
@import url('../assets/css/iosSelect.css');
html {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-family: sans-serif;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    height: 100%;
    font-family: 'Microsoft YaHei';
}

body {
    margin: 0;
    line-height: 1;
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    height: 100%;
}

a,
button,
a:focus,
button:focus,
a:active,
a:hover {
    outline: 0;
}

a {
    -webkit-user-drag: none;
    -webkit-tap-highlight-color: transparent;
    -webkit-tap-highlight-color: transparent;
}

a[href]:hover {
    cursor: pointer;
}

p {
    margin: 0;
    padding: 0;
}

.bg {
    background-image: url(../assets/image/bg@3x.png);
    width: 100%;
    height: 100%;
    background-size: cover;
}

.footer {
    /* position: ;
    bottom: 0.9rem;
    left: 0px; */
    margin-top: 3.3rem;
    width: 100%;
}

.content {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}

.select-div {
    font-family: SFProText-Regular;
    font-size: 0.32rem;
    color: #ffffff;
    letter-spacing: 0;
    margin-top: 0.48rem;
    position: relative;
}
.select-language {
    font-family: SFProText-Regular;
    font-size: 0.32rem;
    color: #00A0A6;
    letter-spacing: 0;
    line-height: 0.32rem;
}

.select-img-left {
    width: 0.12rem;
    margin-right: 0.08rem;
}
.select-img-right {
    width: 0.12rem;
    margin-left: 0.08rem;
}

.img-wrapper {
    padding: 0px 50px;
    text-align: center;
}

.info-wrapper {
    margin-top: 2.4rem;
    width: 100%;
    text-align: center;
}

.download-wrapper {
    width: 100%;
    text-align: center;
    padding: 0px;
    margin-bottom: 95px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.download-wrapper a {
    background-size: 147px 40px;
    width: 6.3rem;
    font-size: 0.32rem;
    height: 0.96rem;
    margin: 0px auto;
    display: block;
    line-height: 0.96rem;
    text-align: center;
    text-decoration: none;
    background: #00A0A6;
    border-radius: 0.48rem;
    font-family: SFProText-Medium;
    color: #ffffff;
    letter-spacing: 0;
}

.lan-sheet {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    display: none;
    background: rgba(0, 0, 0, 0.3);
}

.lan-sheet ul {
    margin: 0px;
    padding: 0px;
    width: 100%;
    height: 510px;
    background: #ededed;
    position: absolute;
    bottom: 0px;
    left: 0px;
    text-align: center;
    opacity: 1;
}

.lan-sheet li {
    margin: 0px;
    padding: 0px;
    list-style: none;
    background: #fff;
    text-decoration: none;
    text-align: center;
    font-size: 18px;
    color: #333333;
    width: 100%;
    height: 50px;
    line-height: 50px;
    opacity: 1;
    position: relative;
}

.lan-sheet li:not(:last-child):after {
    content: '';
    height: 1px;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.12);
    transform: scaleY(0.5);
    -webkit-transform: scaleY(0.5);
    transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
}

.lan-sheet li:last-child {
    margin-top: 10px;
}

.lan-sheet li:last-child img {
    width: 14px;
    clear: both;
    display: block;
    margin: auto;
    padding-top: 18px;
}
#app-introduce {
    font-family: Arial, Helvetica Neue, Helvetica, sans-serif, 'PingFang SC',
        '微软雅黑';
    font-size: 0.4rem;
    color: #000000;
    letter-spacing: 0;
    text-align: center;
    font-weight: bold;
    margin-top: 0.48rem;
}
#app-banner {
    /* padding: 12px 0; */
    opacity: 0.6;
    font-family: Arial, Helvetica Neue, Helvetica, sans-serif, 'PingFang SC',
        '微软雅黑';
    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
    text-align: center;
    line-height: 14px;
}
.ios-select-widget-box .layer {
    height: 302px !important;
    background-color: #f2f2f2;
}
.ios-select-widget-box header.iosselect-header {
    position: absolute;
    bottom: 0px;
    background-color: #ffffff;
}
.ios-select-widget-box header.iosselect-header a.close {
    width: 50%;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #666666;
    letter-spacing: 0.3px;
    text-align: center;
    line-height: 24px;
    border-right: solid 0.5px #f2f2f2;
}
.ios-select-widget-box header.iosselect-header a.sure {
    width: 50%;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0.3px;
    text-align: center;
    line-height: 24px;
    border-left: solid 0.5px #f2f2f2;
}
.cover-area1 {
    top: 99px !important;
}
.cover-area2 {
    top: 151px !important;
}
.logo-wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
}
.logo {
    display: block;
    width: 1.6rem;
    height: 1.6rem;
}
.remind-text {
    font-family: SFProText-Regular;
    font-size: 0.24rem;
    color: #999999;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    width: 5.6rem;
    margin-bottom: 0.32rem;
}
.float-left {
    float: left;
}
</style>
